import { createContext } from 'react';

import { InterstitialsContextType } from './types';

export const InterstitialsContext =
  createContext<InterstitialsContextType | null>(null);
